import router from '@/router/index.js';
import config from '@/config'
import {loginOut} from './api'
import store from '@/store'
function fMoney (s, n) {
  n = n > 0 && n <= 20 ? n : 2
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
  let l = s.split('.')[0].split('').reverse()
  let r = s.split('.')[1]
  let t = ''
  for(let i = 0; i < l.length; i ++ ) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? ',' : '')
  }
  return t.split('').reverse().join('') + '.' + r
}

function toDateTime (date, time) {
  if (!date) return ''
  date = date.toString()
  time = time ? time.toString() : ''
  let str = `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)}`
  if (date.length == 14) {
    str += ` ${date.substr(8, 2)}:${date.substr(10, 2)}:${date.substr(12, 2)}`
  } else if (date.length == 6) {
    str = `${date.substr(0, 2)}:${date.substr(2, 2)}:${date.substr(4, 2)}`
  } else if (time) {
    str += ` ${time.substr(0, 2)}:${time.substr(2, 2)}:${time.substr(4, 2)}`
  }
  return str
}

function fMoney2 (m) {
  return parseFloat(m).toFixed(2)
}

function getNextDate(date, day) {
    var dd = new Date(date);
　　dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
　　return y + "-" + m + "-" + d;
};

function orderreleaseType (sts) {
  const status = {
    '0': '手动发布',
    '1': '定时发布',
  }
  return status[sts] || '未知状态'
}

function removeByValue(arr, val) {
  for(var i=0; i<arr.length; i++) {
      if(arr[i] == val) {
      arr.splice(i, 1);
      break;
      }
  }
}

//返回标题颜色
function table_header(){
  return 'background: #002D72;color:white;padding:10px 0px;text-align:center'
}

// 判断对象值全为空
function objectValueAllEmpty(object){
	var isEmpty = true;
	Object.keys(object).forEach(function(x) {
	    if(object[x] != null && object[x] != ""){
		    isEmpty = false;
	    }
	});
    if(isEmpty){//值全为空
	    return true;
    }
	return false;
}

// 根据id显示角色名
function roleName(rowId){
  switch(rowId){
      case 0:
          return "管理员"
      case 1:
          return "学生"
      case 2:
          return "老师"
      case 3:
          return "在职人员"
      case 4:
          return "待岗"
      case 5:
          return "退休"
  }
}

// 验证码,isabled按钮是否禁用，innerText倒计时，callBack获取验证码回调函数
function virifyCode(timer){
  let isabled = true
  let time = timer
      time --
      if(time == 0){
          isabled = false
      }
      return {
          timer:time,
          isabled
      }
}

// 根据学历展示专业与二级学院(teachingLevel:教学水平;educationalLevel:教育水平；id：角色id)
function isShowCollegeMAjor(teachingLevel,educationalLevel,id){
  let tlevel = teachingLevel
  let elevel = educationalLevel
  let roleId = id
  console.log(id,roleId);
  return tlevel != '小学' &&  tlevel != '普通初中' && tlevel != '普通高中' && elevel != '小学' &&  elevel != '普通初中' && elevel != '普通高中' && roleId != 3 ? true : false
}

//返回上一页
function goBack(){
  router.go(-1)
}

//标题颜色设置
function tableHeader(){
  return 'background:#5278f7;color:white'
}

//弹性布局，如果列表最后一行不足四个，将新建空div进行补充
function setSurplusCount(total,rowCount){
  let surplusCount =  total % rowCount
  if(surplusCount == 0){
    return 0
  }else{
    return rowCount - surplusCount
  }
}

//退出登录
function logout(){
  loginOut().then(res =>{
    sessionStorage.clear()
    store.replaceState({})
    location.href = config.localURL
    location.reload()
  }).catch(err => {})
}

//下载数据
function downloadFileData(methods,url){
  return new Promise((resolve,reject) => {
      let xhr = new XMLHttpRequest();     //定义http请求对象
      xhr.open(methods, url, true);  //定义请求格式，地址
      xhr.setRequestHeader("token",sessionStorage.getItem('token'));//加请求头
      xhr.send();
      xhr.responseType = "blob";  // 返回类型blob
      xhr.onload = function() {   // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
          if (this.status===200) {
              let blob = this.response;
              let reader = new FileReader();
              reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a标签href
              reader.onload=function (e) {
                  // 转换完成，创建一个a标签用于下载
                  let a = document.createElement('a');
                  a.download=`模板文件.xlsx`;            //自定义下载文件名称
                  a.href = e.target.result;
                  document.body.append(a);    // 修复firefox中无法触发click
                  a.click();
                  resolve()
              }
          }else{
              // alert("出现了未知的错误!");
              reject()
          }
      }
  })

}

// 将一个对象的属性作为参数插入到url中
// let obj = {a: '3', b: '4'}
// setObjToUrlParams('www.baidu.com', obj)
// ==>www.baidu.com?a=3&b=4
function setObjToUrlParams(baseUrl, obj){
  let parameters = '';
  for (const key in obj) {
    parameters += key + '=' + encodeURIComponent(obj[key]) + '&';
  }
  parameters = parameters.replace(/&$/, '');
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}
function deepCopy(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    let copy = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            copy[key] = deepCopy(obj[key]);
        }
    }
    return copy;
}
export default{
    deepCopy,
  table_header,
  setObjToUrlParams,
  downloadFileData,
  logout,
  virifyCode,
  roleName,
  isShowCollegeMAjor,
  tableHeader,
  setSurplusCount,
  goBack,
  fMoney,
  fMoney2,
  getNextDate,
  toDateTime,
  orderreleaseType,
  removeByValue,
  objectValueAllEmpty
}
